<template>
  <div class="complaint wrapperstart wrapperitem wrapperend">
    <form
      v-show="!submitted"
      id="complaintform"
      name="form-complaint"
      method="POST"
      class="content-wrapper"
      v-on:submit.prevent="validateFormAndSendForm"
    >
      <div class="form-group">
        <label for="name">Dein Name</label>
        <input id="name" name="name" type="text" required maxlength="50">
      </div>
      <div class="form-group">
        <label for="email">Deine E-Mail Adresse</label>
        <input id="email" name="email" type="email" required>
      </div>

      <div class="form-group">
        <label for="street">Straße</label>
        <input id="street" name="street" type="text" maxlength="50" required>
      </div>
      <div class="form-group">
        <label for="house">Hausnummer</label>
        <input id="house" name="house" type="text" maxlength="10" required>
      </div>
      <div class="form-group">
        <label for="zip">Postleitzahl</label>
        <input id="zip" name="zip" type="text" maxlength="5" minlength="5" required>
      </div>
      <div class="form-group">
        <label for="city">Ort</label>
        <input id="city" name="city" type="text" maxlength="50" required>
      </div>

      <div class="form-group">
        <label for="chargennummer">Chargennummer</label>
        <input id="chargennummer" name="chargennummer" type="text" required>
      </div>

      <div class="form-group">
        <label for="mhd">Mindesthaltbarkeitsdatum</label>
        <input id="mhd" name="mhd" type="text" maxlength="10" required>
      </div>
      <div class="complaint-bg">
        <img :src="$APIURL +'../files/images/backgrounds/contact-bg-theme2.png'">
        <div class="form-group combined-textarea inbox">
          <label for="time">Datum & Uhrzeit</label>
          <input id="time" name="time" type="text" required>
          <label for="message-with-subject">Problembeschreibung</label>
          <textarea id="message-with-subject" name="message" required rows="12"></textarea>
        </div>
        <button type="submit" class="btn btn-circle btn-send-form">
          <span>senden</span>
        </button>
      </div>
    </form>
    <div v-show="submitted">
      <h2 class="text-center">Vielen Dank für Deine Nachricht.</h2>
      <p>
        Wir kümmern uns umgehend um Dein Anliegen.
        <br>Dein Amecke-Team
      </p>
    </div>
  </div>
</template>
<script>
import Base from "./Base.vue";
export default {
  extends: Base,
  props: {
    type: false,
    objectdata: {}
  },

  data() {
    return {
      submitted: false
    };
  },
  mounted() {
    $(document).ready(function() {
      if ($("form").length > 0 && $("input").length > 0) {
        var floatlabels = new FloatLabels("form", {
          transform: "input, select, textarea",
          customLabel: function(labelEl, el) {
            return labelEl.textContent.replace("Pflichtfeld", "");
          }
        });
      }

      if (
        $(".combined-textarea").length > 0 &&
        $('div[class*="fl-wrap-"]').length > 0
      ) {
        // handle floatlabel-active-classes for compi-fields
        let focusClass = "fl-has-focus";
        let activeClass = "fl-is-active";

        let wrapperFlInput = $(".combined-textarea .fl-wrap-input");
        let wrapperFlTextarea = $(".combined-textarea .fl-wrap-textarea");
        // check on load
        // $(wrapperFlInput).each(function(key, value){
        //     $(value)
        // });

        if ($(".combined-textarea .fl-wrap-input").hasClass(activeClass)) {
          $(".combined-textarea .fl-wrap-textarea").addClass(focusClass);
        }
        if ($(".combined-textarea .fl-wrap-textarea").hasClass(activeClass)) {
          $(".combined-textarea .fl-wrap-input").addClass(focusClass);
        }
        // check on focus / blur
        $(".combined-textarea .fl-wrap-textarea textarea").focus(function() {
          $(".combined-textarea .fl-wrap-input").addClass(focusClass);
        });
        $(".combined-textarea .fl-wrap-textarea textarea").blur(function() {
          // console.log($(this));
          if (
            !$(this)
              .parent()
              .hasClass(activeClass)
          ) {
            $(".combined-textarea .fl-wrap-input").removeClass(focusClass);
          }
          if ($(".combined-textarea .fl-wrap-input").hasClass(activeClass)) {
            $(".combined-textarea .fl-wrap-textarea").addClass(focusClass);
          }
        });
        // check on focus / blur
        $(".combined-textarea .fl-wrap-input input").focus(function() {
          $(".combined-textarea .fl-wrap-textarea").addClass(focusClass);
        });
        $(".combined-textarea .fl-wrap-input input").blur(function() {
          if (
            !$(this)
              .parent()
              .hasClass(activeClass)
          ) {
            $(".combined-textarea .fl-wrap-textarea").removeClass(focusClass);
          }
          if ($(".combined-textarea .fl-wrap-textarea").hasClass(activeClass)) {
            $(".combined-textarea .fl-wrap-input").addClass(focusClass);
          }
        });
      }
    });

    this.checkWrapper();
  },
  methods: {}
};
</script>

<style lang="scss">
@import "@/scss/variables.scss";
@import "@/scss/mixins.scss";
.complaint-bg {
  position: relative;
  clear: both;
}
@include min-screen($screen-min-m) {
  form {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .form-group:not(.combined-textarea) {
      flex: 1 48%;

      &:nth-child(even) {
        margin-left: 2%;
      }
    }

    .form-group {
      &.combined-textarea {
        flex: 1 100%;
      }
      &.combined-textarea.inbox {
        position: absolute;
        top: 0;
        left: 5%;
        width: 90%;
        box-shadow: none;
        & input.fl-input,
        & select.fl-select,
        & textarea.fl-textarea {
          background: none;
          border: none;
        }
      }
    }
  }
}
.form-group {
  &.combined-textarea {
    flex: 1 100%;
  }
  &.combined-textarea.inbox {
    position: absolute;
    top: 30px;
    left: 5%;
    width: 90%;
    box-shadow: none;
    & input.fl-input,
    & select.fl-select,
    & textarea.fl-textarea {
      background: none;
      border: none;
    }
  }
}
</style>